import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const SendEmail = lazy(() => import('../../pages/SendEmail/SendEmailPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<SendEmail />} />
    </Routes>
  );
}

export default PagesRoute;
